import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";

export async function sendToWeb3Forms(payload) {
  if (!WEB3FORMS_ACCESS_KEY) return { success: false, skipped: true };
  const body = {
    access_key: WEB3FORMS_ACCESS_KEY,
    subject: `New lead — ${payload.service_interest || "General Enquiry"} · Sunsri Software`,
    from_name: "Sunsri Software Website",
    replyto: payload.email,
    botcheck: "",
    name: payload.name,
    email: payload.email,
    company: payload.company || "-",
    phone: payload.phone || "-",
    service_interest: payload.service_interest || "-",
    message: payload.message,
    source: payload.source || "website",
  };
  const res = await fetch(WEB3FORMS_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { success: !!data.success, message: data.message, status: res.status };
}

export async function getServices() {
  const { data } = await api.get("/services");
  return data.services;
}

export async function getIndustries() {
  const { data } = await api.get("/industries");
  return data.industries;
}
